import type { identifier } from '@core/models/base';

export const STUDIO_SHIPPING = 'Studio Shipping';
export interface ShippingOptionCreateModel {
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;
}

export interface ShippingOptionDisplayModel {
  id: identifier;
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;
}

export interface ShippingOptionUpdateModel {
  code: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
  isEconomyShipping: boolean;
  allowsPOBox: boolean;
  sortIndex: number;
}

export enum ShippingOptions {
  MILITARY = 'priority',
}
